// Author liang gang qiang
// Date 2021-11-24 14:30:39

import * as model from "@/model/mintalMes/prd/MintalMesPrdDowntimePlanModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdDowntimePlan(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
